import script from "./ProcessoWorkflow_76.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessoWorkflow_76.vue?vue&type=script&setup=true&lang=js"

import "./ProcessoWorkflow_76.vue?vue&type=style&index=0&id=fe2a7f00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe2a7f00"]])

export default __exports__